import { GradientBar } from '@salecycle/ui-component-library';
import { FC } from 'react';
import styled from 'styled-components';
import Spinner from './spinner';

const StyledAppLoader = styled.div<IProps>`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface IProps {
  showGradient?: boolean;
}

const AppLoader: FC<IProps> = ({ showGradient }) => (
  <StyledAppLoader>
    {showGradient && <GradientBar variation={import.meta.env.VITE_ENV === 'production' ? 'prod' : 'poc'} />}
    <Spinner />
  </StyledAppLoader>
);

export default AppLoader;
